import styles from "./rb22.module.scss"
import { useState } from "react"

// Images
import Background from "../../components/background/background"
import RB22Image from "../../assets/images/graphics/rb22.png"
import RB22Title from "../../assets/images/graphics/rb22-title.svg"

// UI components
import Touchpoint from "./touchpoint/touchpoint"

// Returns the HTML markup for the ops room slide
export default function RB22() {
	const [active, setActive] = useState(null)

	return (
		<>
			<Background />

			<div
				className={styles.container}
				style={{ backgroundImage: `url("${RB22Image}")` }}>
				<img
					src={RB22Title}
					className={styles.carName}
				/>

				<Touchpoint
					id="frontWing"
					// translationKey="FrontWingAndNoseCone"
					title="Front Wing"
					content="The new front wing is 100mm narrower than that of the previous generation of cars. It features a two-element active flap. That flap will be closed in high downforce Corner Mode and open on selected straights where a low-drag configuration will help with energy management. The narrower wing is also designed to minimise outwash."
					active={active}
					setActive={setActive}
				/>
				<Touchpoint
					id="bargeBoards"
					// translationKey="BargeBoardsWheelCovers"
					title="Barge Boards &amp; Wheel Covers"
					content="Dirty air is being tackled again with the new cars and one part of the solution is in-washing bargeboards. These will sit in front of the sidepods and should make wake control a bit easier. The over-wheel ‘eyebrows’ we saw on the ’22 cars are also gone."
					active={active}
					setActive={setActive}
				/>
				<Touchpoint
					id="halo"
					// translationKey="Halo"
					title="Halo"
					content="The Halo cockpit-protection device continues to be a key safety requirement under the sport’s updated technical regulations, with the FIA even seeking a new lightweight version that trims about 1 kg from the current design  whilst still withstanding 12 tonnes of weight."
					active={active}
					setActive={setActive}
				/>
				<Touchpoint
					id="floor"
					// translationKey="Floor"
					title="Floor"
					content="2026 floors are much simpler, flatter affairs with extended diffusers with bigger openings. The RB22 floor and diffuser arrangement reflects that concept. The diffuser is likely to be less powerful than in previous generations."
					active={active}
					setActive={setActive}
				/>
				<Touchpoint
					id="tyres"
					// translationKey="CoolingAndSidePods"
					title="Tyres"
					content="F1 is sticking with 18” wheels but the tyres are now smaller. The tread width is 25mm less at the front and 30mm less at the rear. The total diameter is also 15mm less at the front and 10mm less at the rear. Pirelli will continue to provide three compounds (Hard, Medium and Soft), along with the intermediate and full wet."
					active={active}
					setActive={setActive}
				/>
				<Touchpoint
					id="rearWing"
					// translationKey="RearWing"
					title="Rear Wing"
					content="A three-element active rear wing which in Straight line Mode will open to reduce drag, thus requiring less energy to get to the end of straight and in Corner Mode it will close to provide maximum downforce. The rear of the car has undergone another change with the beam wing – the small horizontal plane underneath the main rear wing"
					active={active}
					setActive={setActive}
				/>

				<div
					className={styles.reset}
					onClick={() => setActive(null)}
				/>
			</div>
		</>
	)
}
